import React from 'react'
import './style.css'
import { A, P } from '@driftt/tide-core'

const ChatLink = (props) => (
    <P className="chat-link">Need help? <A onClick={ () => { if (window.drift) window.drift.api.openChat() } }> Chat with us! </A> </P>
)

export default ChatLink
